import { useEffect, useState } from 'react';

import { releaseFetchWithOverrideRecovery } from '@/lib/release/pageSourceOverride';

const OVERRIDE_SESSION_ENDPOINT = '/e/api/override-session';

export function useOverrideSession(): boolean {
  const [active, setActive] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    let cancelled = false;
    void (async () => {
      try {
        const response = await releaseFetchWithOverrideRecovery(OVERRIDE_SESSION_ENDPOINT, {
          credentials: 'same-origin',
          cache: 'no-store',
        });
        const body: unknown = response.ok ? await response.json() : null;
        const isActive =
          typeof body === 'object' && body !== null && (body as { active?: unknown }).active === true;
        if (!cancelled) setActive(isActive);
      } catch {
        if (!cancelled) setActive(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return active;
}
